import { LazyLoad } from 'app/utils';

export const SurveyResponseDetailPage = LazyLoad(
  () => import('./index'),
  (module) => module.SurveyResponseDetailPage,
);
